import React from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';

import { useStore } from '../stores';
import { Layers, Modals } from '../stores/layers';
import { useTranslateFunction } from '../helpers/useTranslationHook';

export const AddLocationHelpModal = observer(() => {
  const { t } = useTranslateFunction(Layers.myLocations);
  const { layers, myLocations } = useStore();

  const abort = () => {
    layers.closeModal();
    myLocations.deactivate();
  };

  const confirm = () => {
    myLocations.activate();
  };

  const notificationClass = classNames(
    'no-scrollbar bg-black/80 w-[calc(100%_-_30px)] py-3 pl-16 pr-10 text-white fixed left-1/2 z-50 -translate-x-1/2 rounded-lg lg:w-1/2 lg:left-[calc(50%_+_150px)] transition-all',
    {
      'opacity-100 visible bottom-28 lg:bottom-6':
        layers.activeModal === Modals.addLocationHelp,
      'opacity-0 invisible bottom-0':
        layers.activeModal !== Modals.addLocationHelp,
    },
  );

  if (layers.activeModal === Modals.addLocationHelp) {
    confirm();
  }

  return (
    <div className={notificationClass}>
      <span
        onClick={abort}
        className="icon icon-close cursor-pointer absolute top-3 right-3"
      />
      <span className="icon icon-region text-3xl absolute top-1/2 left-5 -translate-y-1/2" />
      {t('modal-help-description')}
    </div>
  );
});
